// Full Arabic translation extension — covers benefits / scope / whyUs / faqs
// for the 17 SEO service pages. Merges into AR_SERVICES at runtime so existing
// EN data + key-SEO AR overlay still work unchanged.

export const AR_SERVICES_FULL = {
  "soft-fm": {
    benefits: [
      "فاتورة واحدة، مشرف واحد، SLA واحد — يحل محل 3-5 موردين متفرقين",
      "طاقم مدرّب، بزّة موحدة، بطاقة هوية تحت كفالة أوريون",
      "خدمات نهارية وليلية وعطلات نهاية الأسبوع وفرق دعم للذروة",
      "مواد كيميائية معتمدة من البلدية وصديقة للبيئة",
      "تتبع حضور مباشر وتقارير KPI شهرية",
    ],
    scope: [
      "خدمات تدبير منزلي يومية وعمال دعم نهاري",
      "نظافة دورات المياه وإعادة التعبئة ومكافحة الروائح",
      "تنظيف الزجاج والرخام والأسطح المرتفعة",
      "مكافحة آفات بمواد معتمدة من البلدية",
      "تنسيق حدائق وري وصيانة خارجية",
      "فصل النفايات وتنسيق التخلص منها",
      "تنظيف عميق للمطابخ ومناطق الطعام",
      "تجهيز للفعاليات الخاصة",
    ],
    whyUs: [
      "خبرة عميقة في إدارة المرافق بالإمارات",
      "أوقات استجابة مقاسة شهرياً وفق SLA",
      "تغطية متخصصة: مطابخ HACCP، عيادات DHA، مدارس KHDA",
      "قدرة على ضخ عمالة 72 ساعة للفعاليات",
    ],
    faqs: [
      { q: "ما الفرق بين FM الهارد والسوفت؟", a: "FM الهارد يغطي أنظمة المبنى (تكييف، MEP، كهرباء، حريق). FM السوفت يغطي خدمات المستخدم (نظافة، آفات، حدائق، نفايات). أوريون يقدم كليهما في عقد واحد." },
      { q: "هل يمكنني توسيع أو تقليص FM السوفت شهرياً؟", a: "نعم. عقودنا تشمل بنود مرونة لمواسم الذروة والفعاليات — قدرة على ضخ حتى 500 موظف في 72 ساعة." },
      { q: "هل مواد التنظيف آمنة للمرافق الصحية والغذائية؟", a: "نعم. نستخدم منتجات HACCP للأغذية والمشروبات ومواد معتمدة من DHA/DOH للرعاية الصحية." },
    ],
  },

  "hard-fm": {
    benefits: [
      "تقويم PPM وقائي يشمل التكييف وMEP والحريق والكهرباء والسباكة",
      "فنيون مسجلون لدى DEWA وADDC وSEWA",
      "استجابة طوارئ 24/7 ضمن SLA (30 دقيقة للحالات الحرجة)",
      "امتثال للدفاع المدني للسلامة من الحريق",
      "سجل أصول، تقارير KPI شهرية، مراجعات أعمال ربعية",
    ],
    scope: [
      "خدمة التكييف وإزالة الترسبات وPPM للمبردات",
      "صيانة MEP وقائية (ميكانيك، كهرباء، سباكة)",
      "PPM لإنذار الحريق والرشاشات وإضاءة الطوارئ",
      "معايرة BMS / FCU",
      "اختبار المولدات وUPS وحمل المختبر",
      "اختبار Legionella لأبراج التبريد",
      "AMC للمصاعد والسلالم المتحركة والتحكم بالدخول",
      "استجابة طارئة 24/7",
    ],
    whyUs: [
      "مهندسون معتمدون من DEWA وADDC وSEWA والدفاع المدني",
      "PPM للمبردات وBMS وFCU وأنظمة الانقسام على نطاق واسع",
      "نقطة اتصال واحدة وفوترة شهرية موحدة",
      "نشر فوري للطوارئ في أي مكان في الإمارات",
    ],
    faqs: [
      { q: "كم مرة يجب صيانة التكييف في مباني الإمارات؟", a: "التكييف التجاري يحتاج PPM شهري. التكييف السكني يحتاج خدمة ربعية. غبار وحرارة الإمارات يسرعان البلى." },
      { q: "هل المهندسون معتمدون من DEWA والدفاع المدني؟", a: "نعم. جميع طاقم الهندسة تحت كفالتنا ويحمل الاعتمادات اللازمة من DEWA أو ADDC أو SEWA أو الدفاع المدني." },
      { q: "ما SLA الاستجابة للطوارئ؟", a: "30 دقيقة للحرجة (سلامة، فيضان)، ساعتان للكبيرة، 8 ساعات للصغيرة — مقاسة شهرياً." },
    ],
  },

  "deep-cleaning-uae": {
    benefits: [
      "تنظيف بالبخار والشفط والكيمياء لكل الأسطح",
      "إزالة دهون المطبخ والفرن والشفاط",
      "إزالة الترسبات وإعادة فاصل البلاط وتطهير الحمامات",
      "تنظيف فتحات وقنوات وفلاتر التكييف",
      "غسيل بالشامبو للأثاث والمراتب والكنب والسجاد",
    ],
    scope: [
      "غرفة المعيشة وغرف النوم والممرات",
      "المطبخ والأجهزة والفرن والشفاط",
      "الحمامات وإزالة الترسبات والتطهير",
      "قنوات وفتحات وفلاتر التكييف",
      "النوافذ والزجاج والمرايا والشرفات",
      "غسيل السجاد والكنب والمراتب",
      "تنظيف وتلميع الأرضيات المبلطة",
      "حزم إعادة الضبط للانتقال",
    ],
    whyUs: [
      "مواد معتمدة من البلدية ومتوافقة مع DHA",
      "فرق مدربة ومُحقَّق منها وبزة موحدة",
      "حجوزات نفس اليوم وعطلات نهاية الأسبوع",
      "ضمان الرضا — نعيد تنظيف أي منطقة فاتت مجاناً",
    ],
    faqs: [
      { q: "كم تستغرق عملية التنظيف العميق؟", a: "شقة غرفة واحدة تستغرق 3-4 ساعات، فيلا 6-10 ساعات، مكتب 4-8 ساعات حسب الحجم والحالة." },
      { q: "هل تجلبون معداتكم ومواد التنظيف؟", a: "نعم. المكانس والبخار والمنظفات والسلالم وجميع المواد المعتمدة من البلدية مشمولة في السعر." },
      { q: "هل التنظيف العميق آمن للأطفال والحيوانات الأليفة؟", a: "نعم. نستخدم مواد صديقة للبيئة عند الطلب. أخبرنا بأي حساسيات عند الحجز." },
    ],
  },

  "hvac-maintenance-uae": {
    benefits: [
      "PPM ربعي يمد عمر الضاغط 30-50%",
      "الملفات النظيفة تخفض فواتير الكهرباء 15-25%",
      "كشف تسريبات الغاز قبل توقف الوحدة",
      "تحسين جودة الهواء وتقليل المسببات",
      "امتثال DEWA للمباني التجارية",
    ],
    scope: [
      "صيانة مكيفات الاسبليت وشحن الغاز وتنظيف الفلاتر",
      "PPM للمبردات المركزية وإزالة الترسبات",
      "صيانة FCU وAHU",
      "تنظيف وتعقيم القنوات",
      "اختبار Legionella لأبراج التبريد",
      "معايرة وضبط BMS",
      "استجابة للطوارئ (تسرب، عدم تبريد، عطل)",
      "عقود الصيانة السنوية (AMC)",
    ],
    whyUs: [
      "مهندسو HVAC معتمدون من DEWA وADDC وSEWA",
      "قطع غيار أصلية من موزعين معتمدين",
      "زيارات طوارئ نفس اليوم في الإمارات",
      "خطط AMC بأوقات استجابة SLA",
    ],
    faqs: [
      { q: "كم مرة يجب صيانة المكيف في الإمارات؟", a: "كل 3 أشهر للسكني، PPM شهري للتجاري. غبار وحرارة الإمارات تسرع انسداد الفلاتر وفقد الغاز." },
      { q: "هل تتعاملون مع المبردات المركزية وBMS؟", a: "نعم. فريقنا التجاري يخدم مبردات York وCarrier وTrane وDaikin وMcQuay ويتكامل مع منصات BMS الرئيسية." },
      { q: "ما المشمول في AMC للتكييف؟", a: "PPM ربعي، زيارات طوارئ غير محدودة، استبدال الفلاتر، شحن الغاز، وتقرير أداء شهري." },
    ],
  },

  "plumbing-services-uae": {
    benefits: [
      "استجابة طارئة نفس اليوم للتسريبات والانسدادات",
      "سباكون مرخصون ومؤمَّن عليهم",
      "كشف تسريبات بالتصوير الحراري والصوتي",
      "أسعار ثابتة — لا مفاجآت",
      "ضمان على جميع الإصلاحات والتركيبات",
    ],
    scope: [
      "كشف تسريبات وإصلاح الأنابيب",
      "تنظيف الصرف وفك الانسدادات",
      "تنظيف خزانات المياه (معتمد من البلدية)",
      "تركيب التركيبات الصحية",
      "إصلاح وتركيب سخان المياه",
      "تنظيف مصايد الشحوم",
      "تركيب وPPM لمضخات الضغط",
      "تجديدات سباكة المطبخ والحمام",
    ],
    whyUs: [
      "شهادة تنظيف خزانات معتمدة من بلدية دبي",
      "خط طوارئ 24/7 في الإمارات",
      "مدربون على جميع علامات السباكة — Grohe وHansgrohe وToto وKohler",
      "تأمين ضد دعاوى أضرار المياه",
    ],
    faqs: [
      { q: "كم سرعة الوصول في حالة الطوارئ؟", a: "خلال 60 دقيقة في دبي والشارقة وعجمان. 90 دقيقة لأبوظبي والمناطق النائية." },
      { q: "هل تقدمون شهادة تنظيف خزان معتمدة؟", a: "نعم. نحن مرخصون من بلدية دبي ونصدر شهادات امتثال بعد كل عملية تنظيف." },
      { q: "هل السباكون مؤمَّن عليهم؟", a: "نعم. كل سباك في أوريون يحمل تأميناً عاماً ضد دعاوى أضرار المياه." },
    ],
  },

  "electrical-services-uae": {
    benefits: [
      "كهربائيون مسجلون لدى DEWA وADDC وSEWA",
      "كشف أعطال وإصلاح طارئ نفس اليوم",
      "تصميم إضاءة وترقيات موفرة للطاقة",
      "اختبار التأريض وRCD وتوازن الحمل",
      "شهادات امتثال للتسليم وAMC",
    ],
    scope: [
      "كشف الأعطال والإصلاح الطارئ",
      "تركيب وتصميم الإضاءة",
      "ترقية لوحات DB وإعادة التوصيل",
      "اختبار التأريض وRCD",
      "تركيبات منزل ذكي وKNX",
      "صيانة الألواح الشمسية",
      "تركيب المولدات وUPS",
      "أعمال كهربائية للتشطيب",
    ],
    whyUs: [
      "مرخصون من جميع جهات الكهرباء في الإمارات",
      "عمل مدعوم بتأمين وضمان مكتوب",
      "مهندسون مدربون على المنزل الذكي وKNX",
      "نشر فوري في الإمارات",
    ],
    faqs: [
      { q: "هل الكهربائيون مرخصون من DEWA؟", a: "نعم. جميع كهربائيي أوريون يحملون تراخيص سارية من DEWA أو ADDC أو SEWA حسب الإمارة." },
      { q: "هل تتعاملون مع تركيبات المنزل الذكي؟", a: "نعم. مدربون على KNX وLutron وCrestron وبروتوكولات المنزل الذكي الرئيسية." },
      { q: "هل تصدرون شهادات امتثال؟", a: "نعم. للتشطيبات التجارية وAMC نصدر شهادات امتثال متوافقة مع DEWA بعد الاختبار." },
    ],
  },

  "handyman-services-uae": {
    benefits: [
      "فني شامل يتعامل مع عدة مهام في زيارة واحدة",
      "أسعار ثابتة بالساعة أو بالمهمة",
      "فنيون مُحقَّق منهم وبزة موحدة ومؤمَّن عليهم",
      "حجوزات نفس اليوم وعطلات نهاية الأسبوع",
      "تسعيرة مجانية قبل بدء أي عمل",
    ],
    scope: [
      "تركيب التلفاز والرفوف والستائر",
      "تجميع الأثاث (إيكيا، Home Centre، إلخ)",
      "دهان بسيط ولمسات",
      "تعديل الأبواب والأقفال والمفصلات",
      "إعادة الفاصل وإحكام البلاط بالسيليكون",
      "تركيب الإضاءة ومراوح السقف",
      "إصلاحات سباكة بسيطة (صنابير، أحواض، سدادات)",
      "تعليق الصور والتركيب على الجدران",
    ],
    whyUs: [
      "فنيون متعددو المهارات — دهان وخشب وكهرباء وسباكة أساسية",
      "تأمين ضد الأضرار والحوادث في الموقع",
      "حجوزات نفس اليوم عبر WhatsApp",
      "مدعومون بفريق FM الكامل لأوريون عند الحاجة",
    ],
    faqs: [
      { q: "ما الحد الأدنى لوقت الحجز؟", a: "ساعتان. معظم العملاء ينجزون 3-5 مهام صغيرة في تلك الفترة." },
      { q: "هل أحتاج لتوفير المواد؟", a: "للأعمال المعقدة (دهان، بلاط) ننصح بتوفير الخامات — نحضر الأدوات والمستهلكات." },
      { q: "هل يمكنكم القيام بأعمال كهربائية أو سباكة؟", a: "للإصلاحات البسيطة نعم. للأعمال الكبيرة نحيلها لفرقنا المرخصة." },
    ],
  },

  "snagging-services-uae": {
    benefits: [
      "اكتشف مئات العيوب قبل توقيع التسليم",
      "أجبر المطور على الإصلاح تحت الضمان",
      "مستقلون — لا نعمل لصالح المطور",
      "تقرير مفصل بالصور ومواقع العيوب",
      "خدمة إعادة فحص للتحقق من الإصلاحات",
    ],
    scope: [
      "الجدران والأرضيات والأسقف والتشطيبات",
      "النجارة والأبواب والمطبخ والخزائن",
      "الحمامات والصحية والفواصل",
      "النقاط الكهربائية والمفاتيح والإضاءة",
      "تشغيل التكييف والقنوات",
      "ضغط السباكة والصرف",
      "النوافذ والشرفات والأعمال الخارجية",
      "تقرير مصور بمواقع العيوب",
    ],
    whyUs: [
      "مستقلون — لا يدفع لنا المطورون أبداً",
      "فحوصات واعية بـ DEWA والدفاع المدني والسباكة",
      "تقارير تسلم خلال 48 ساعة بصور ومواقع",
      "إعادة فحص للتحقق من إصلاحات المطور",
    ],
    faqs: [
      { q: "متى يجب إجراء فحص العيوب؟", a: "قبل توقيع وثائق التسليم — هذه هي ورقتك الرابحة. ننصح بالحجز قبل 7-14 يوم من التسليم." },
      { q: "هل يجب على المطور إصلاح العيوب؟", a: "بموجب قانون الإمارات ومعظم اتفاقيات SPA، يجب على المطورين معالجة العيوب خلال فترة الضمان." },
      { q: "هل إعادة الفحص مشمولة؟", a: "تُقدَّم بنصف الرسوم الأصلية للتحقق من أن المطور أصلح كل شيء." },
    ],
  },

  "airbnb-management-uae": {
    benefits: [
      "تنظيف تسليم/استلام نفس اليوم",
      "أغطية ومناشف بمستوى الفنادق",
      "تقديم 5 نجوم: تجهيز السرير، إعداد المرافق، عطر",
      "خط طوارئ للصيانة لقضايا الضيوف",
      "تقارير مصورة بعد كل تنظيف للمضيف",
    ],
    scope: [
      "تنظيف تسليم/استلام نفس اليوم",
      "استبدال أغطية ومناشف بمستوى فندقي",
      "إعداد طاقم مرافق (مستحضرات، ماء، قهوة)",
      "تنسيق إعادة تعبئة المطبخ",
      "زيارات طوارئ للتكييف والسباكة والكهرباء",
      "تقرير مصور بعد كل تنظيف",
      "برامج تنظيف عميق شهرية",
      "حزمة ترحيب وعطر مميز",
    ],
    whyUs: [
      "وعي بعمليات DTCM (لوائح منازل العطلات في دبي)",
      "مدبرات منزل مدربات فندقياً",
      "إدارة الأغطية والمرافق والمستهلكات نيابة عنك",
      "حجز وتقارير عبر WhatsApp للمضيفين",
    ],
    faqs: [
      { q: "ما سرعة خدمة التسليم؟", a: "معظم عمليات التسليم لاستوديو وغرفة واحدة تستغرق 90 دقيقة. غرفتان أقل من ساعتين. الفلل 3-4 ساعات." },
      { q: "هل تتعاملون مع امتثال DTCM؟", a: "نعمل وفق معايير DTCM لمنازل العطلات لكن رخصة التأجير مسؤولية المضيف." },
      { q: "هل يمكنكم التعامل مع مشاكل الصيانة من الضيوف؟", a: "نعم. يمكن للضيوف مراسلة خط WhatsApp مباشرة — نرد خلال 60 دقيقة." },
    ],
  },

  "move-in-move-out-cleaning": {
    benefits: [
      "مبني على قائمة تسليم المالك القياسية في الإمارات",
      "ضمان استرداد الوديعة — نعيد تنظيف أي منطقة فاتت",
      "فرق مرخصة من البلدية ومواد معتمدة",
      "حجوزات نفس اليوم وعطلات نهاية الأسبوع",
      "تقرير مصور عند الانتهاء",
    ],
    scope: [
      "المطبخ — الفرن والشفاط والثلاجة والخزائن والأدراج",
      "الحمامات — إزالة الترسبات والفواصل والمرايا",
      "غرف النوم — الخزانة والألواح والمراوح والإضاءة",
      "المعيشة — شفط ومسح وتنظيف جميع الأسطح",
      "تنظيف فتحات وفلاتر التكييف",
      "النوافذ (الداخلية) والشرفات",
      "تنظيف خدوش وعلامات الجدار",
      "تقرير نهائي مصور",
    ],
    whyUs: [
      "إجراءات مبنية على قائمة المالك",
      "عمليات مرخصة من البلدية ومؤمَّنة",
      "تنظيف مجاني إذا فات أي شيء",
      "تنسيق مع شركات النقل والملاك",
    ],
    faqs: [
      { q: "هل سيعيد لي هذا التنظيف الوديعة؟", a: "إذا كانت وحدتك في حالة طبيعية، تنظيفنا يلبي معايير المالك. نقدم إعادة تنظيف مجانية إذا أثار المالك قضايا خلال 48 ساعة." },
      { q: "هل يجب أن أكون موجوداً أثناء التنظيف؟", a: "يفضل عند الوصول والمغادرة للتوقيع. أو يمكن لأمن المبنى السماح بالدخول بالتنسيق." },
      { q: "كم تستغرق العملية؟", a: "غرفة واحدة تستغرق 4-5 ساعات، فيلا 8-10 ساعات. نرسل 2-3 منظفين لإنجاز الوقت." },
    ],
  },

  "office-cleaning-uae": {
    benefits: [
      "تكرار يومي أو أسبوعي أو لمرة واحدة — اختيارك",
      "تنظيف خارج ساعات العمل لتجنب الإزعاج",
      "مشرف مخصص لكل موقع، بدون تبديل",
      "إدارة المستهلكات (مناديل، صابون، إعادة تعبئة)",
      "تقارير أداء شهرية وتتبع حضور مباشر",
    ],
    scope: [
      "تنظيف محطة العمل والمكتب والصديق للتكنولوجيا",
      "إعادة ضبط غرفة الاجتماعات بين الحجوزات",
      "تنظيف عميق للمطبخ وغرفة الاستراحة",
      "نظافة دورات المياه والتعبئة",
      "تنظيف الفواصل الزجاجية والأبواب",
      "شفط السجاد ومعالجة البقع",
      "جمع وفصل النفايات",
      "عامل دعم نهاري ودعم استقبال",
    ],
    whyUs: [
      "بزة موحدة، بطاقة هوية، مرخصون من البلدية",
      "خيارات عامل نهاري ووردية ليلية",
      "تغطية في جميع الإمارات السبع",
      "مدعومون بفريق FM الكامل عند الحاجة",
    ],
    faqs: [
      { q: "هل توفرون مستلزمات التنظيف؟", a: "نعم. جميع مواد التنظيف والمعدات والمستهلكات (مناديل، صابون يدوي، أكياس قمامة) مشمولة." },
      { q: "هل تنظفون خارج ساعات العمل؟", a: "نعم. معظم عملائنا يُنظَّفون بين 8 مساءً و6 صباحاً." },
      { q: "هل تتعاملون مع المكاتب الصغيرة (أقل من 500 قدم)؟", a: "نعم. لدينا حزم أسبوعية ونصف أسبوعية للمكاتب الصغيرة وفضاءات العمل المشتركة." },
    ],
  },

  "villa-maintenance-uae": {
    benefits: [
      "عقد واحد يغطي التكييف والسباكة والكهرباء والنجارة والدهان",
      "صيانة تكييف وقائية ربعية مشمولة",
      "زيارات طوارئ 24/7 في الإمارات",
      "تكلفة سنوية ثابتة — بدون فواتير مفاجئة",
      "مشرف مخصص وخط WhatsApp ساخن",
    ],
    scope: [
      "صيانة التكييف الربعية (جميع الاسبليت)",
      "إصلاحات السباكة وكشف التسريبات",
      "كشف الأعطال الكهربائية وإصلاحها",
      "إصلاحات النجارة والأبواب والمفاصل",
      "لمسات دهان (مناطق صغيرة)",
      "صيانة الحديقة والمسبح والشواء (متميز)",
      "تنسيق مكافحة الآفات",
      "خط طوارئ 24/7",
    ],
    whyUs: [
      "فنيون معتمدون من DEWA وADDC وSEWA",
      "استجابة طوارئ نفس اليوم",
      "مركبات بعلامة تجارية وفرق بزة موحدة",
      "مؤمَّنون ضد الأضرار وتعويض العمال",
    ],
    faqs: [
      { q: "ما المشمول في AMC الفيلا؟", a: "صيانة تكييف ربعية، زيارات طوارئ غير محدودة، إصلاحات سباكة وكهرباء ونجارة بسيطة وخط ساخن 24/7." },
      { q: "هل يمكنني إضافة المسبح والحديقة ومكافحة الآفات؟", a: "نعم. AMC المتميز يشمل كيمياء المسبح وصيانة أسبوعية للحديقة ومكافحة آفات شهرية." },
      { q: "ما سرعة استجابة الطوارئ؟", a: "خلال 60 دقيقة في دبي والشارقة وعجمان. 90 دقيقة لأبوظبي." },
    ],
  },

  "annual-maintenance-contract": {
    benefits: [
      "رسوم شهرية ثابتة — OPEX متوقع، بدون مفاجآت",
      "أوقات استجابة SLA (30 دقيقة حرج، ساعتان كبير، 8 ساعات صغير)",
      "PPM ربعي للتكييف والسباكة والكهرباء والحريق",
      "مدير حساب مخصص ونقطة اتصال واحدة",
      "تقارير أداء شهرية ومراجعات أعمال ربعية",
    ],
    scope: [
      "تقويم PPM المجدول (HVAC، MEP، حريق، كهرباء)",
      "زيارات طوارئ غير محدودة ضمن SLA",
      "مشرف ومدير حساب مخصص",
      "تقارير KPI شهرية وسجل أصول",
      "مراجعات أعمال ربعية",
      "دعم امتثال الدفاع المدني والحريق",
      "إدارة قطع الغيار",
      "امتثال HSE وتأمين",
    ],
    whyUs: [
      "خبرة عميقة في FM بالإمارات",
      "معتمدون من DEWA وADDC وSEWA والدفاع المدني",
      "تغطية في جميع الإمارات السبع",
      "تقارير شفافة شهرية لكل زيارة",
    ],
    faqs: [
      { q: "ما الحد الأدنى لمدة عقد AMC؟", a: "12 شهراً. بعض العملاء يديرون AMC لـ 24 أو 36 شهراً بأسعار مثبتة." },
      { q: "هل القطع مشمولة في رسوم AMC؟", a: "المستهلكات الروتينية (فلاتر، تجهيزات أساسية) مشمولة. القطع الكبيرة بسعر التكلفة بدون هامش." },
      { q: "هل يمكنني الإلغاء في منتصف العقد؟", a: "نعم، بإشعار 60 يوماً. استرداد بنسبة لزيارات PPM غير المستخدمة." },
    ],
  },

  "post-construction-cleaning": {
    benefits: [
      "عملية من 3 مراحل: خشن، مقاول، لامع",
      "معدات متخصصة لاستخراج الغبار",
      "إزالة رذاذ الدهان والمواد اللاصقة وبقايا الفواصل",
      "متوافق مع قوائم العيوب — يعمل مع مفتشي الفحص",
      "تشطيب جاهز للدفاع المدني والتسليم",
    ],
    scope: [
      "استخراج الغبار من كل الأسطح",
      "إزالة رذاذ الدهان والمواد اللاصقة",
      "إزالة بقايا الفواصل والبلاط",
      "تنظيف النوافذ والإطارات والشرفات",
      "مسح المطبخ والأجهزة والخزائن",
      "إزالة الترسبات وتلميع الحمام",
      "تنظيف فتحات وقنوات التكييف",
      "تنظيف لامع نهائي قبل التسليم",
    ],
    whyUs: [
      "مدربون على إجراءات تنظيف المقاول وإزالة الفواصل",
      "معدات شفط HEPA واستخراج غبار",
      "تنسيق مع المطورين ومقاولي التشطيب",
      "فرق على نطاق واسع (10-30 موظف) للمشاريع الكبيرة",
    ],
    faqs: [
      { q: "متى يجب حجز تنظيف ما بعد البناء؟", a: "حدد تنظيف المقاول فور انتهاء الأعمال الرئيسية، والتنظيف اللامع قبل 24-48 ساعة من التسليم." },
      { q: "هل تزيلون رذاذ الدهان وبقايا الفواصل؟", a: "نعم. هاتان أصعب بقيتين ونستخدم مواد متخصصة لإزالتهما دون إتلاف التشطيبات." },
      { q: "هل يمكنكم التعامل مع التشطيبات التجارية الكبيرة؟", a: "نعم. نظفنا مكاتب ووحدات تجزئة تصل إلى 50,000 قدم بفرق من 30 موظف." },
    ],
  },

  "pest-control-uae": {
    benefits: [
      "مواد معتمدة من البلدية",
      "إجراءات متوافقة مع HACCP والبلدية لعملاء الأغذية",
      "مواعيد نفس اليوم وعطلات نهاية الأسبوع",
      "إعادة معالجة مجانية إذا عادت الآفات ضمن الضمان",
      "خيارات بدون رائحة مزعجة",
    ],
    scope: [
      "علاج الصراصير بالجل والرش",
      "علاج بق الفراش بالحرارة والكيمياء",
      "حواجز النمل الأبيض قبل/بعد البناء",
      "إغواء وحجب القوارض",
      "مكافحة النمل والسمك الفضي والديدان الألفية",
      "مكافحة البعوض والذباب",
      "إزالة الدبابير والنحل",
      "عقود إدارة الآفات لعملاء HACCP",
    ],
    whyUs: [
      "مرخصون من بلدية دبي وADM",
      "متوافقون مع HACCP للمطاعم ومواقع الأغذية",
      "مدربون على إدارة الآفات المتكاملة (IPM)",
      "ضمان إعادة معالجة مجاني",
    ],
    faqs: [
      { q: "هل المواد آمنة للأطفال والحيوانات الأليفة؟", a: "نعم. نستخدم مواد معتمدة من البلدية منخفضة السمية للسكني وننصح بأوقات العودة الآمنة." },
      { q: "هل تتعاملون مع بق الفراش؟", a: "نعم — نقدم علاجات كيميائية وحرارية. العلاج الحراري أكثر فعالية وخالٍ من المواد الكيميائية." },
      { q: "ما مدة الضمان؟", a: "30 يوماً للآفات العامة، 90 يوماً لبق الفراش، 12 شهراً لحواجز النمل الأبيض." },
    ],
  },

  "disinfection-services-uae": {
    benefits: [
      "مواد بمستوى المستشفيات مختبرة على الفيروسات والبكتيريا",
      "ضباب ULV (حجم منخفض جداً) للتغطية الكاملة",
      "مواد معتمدة من البلدية ومتوافقة مع DHA/DOH",
      "شهادات تعقيم تُصدَر عند الانتهاء",
      "استجابة طارئة نفس اليوم",
    ],
    scope: [
      "ضباب ULV عبر المساحة كاملة",
      "تعقيم الأسطح (نقاط اللمس، المكاتب، الإلكترونيات)",
      "تعقيم فتحات وقنوات التكييف",
      "تعقيم عميق للحمامات",
      "تعقيم المطبخ",
      "ضباب الأثاث (الكنب، الستائر)",
      "اختبار بقايا الكيمياء",
      "شهادة تعقيم عند الانتهاء",
    ],
    whyUs: [
      "مواد مصدَّقة مختبرة على COVID-19 وMRSA والإنفلونزا",
      "خيارات ضباب ULV وأسطح ورش كهروستاتيكي",
      "مدربون على معدات الحماية وإدارة النفايات",
      "شهادة تعقيم للامتثال",
    ],
    faqs: [
      { q: "متى يمكن العودة للمساحة؟", a: "عادة 2-4 ساعات بعد التضبيب. نحدد وقت العودة الدقيق حسب المادة والتهوية." },
      { q: "هل المواد آمنة للأطفال ومرضى الربو؟", a: "نعم. يمكننا استخدام تعقيم سطحي صديق للبيئة وغير هباء جوي للسكان الحساسين." },
      { q: "هل تصدرون شهادة تعقيم؟", a: "نعم. للعملاء التجاريين والعيادات نصدر شهادة مرقمة بالمواد المستخدمة وأوقات العودة." },
    ],
  },
};
